import { styled } from '../setup'
import { borders, colors, spacing, typography } from '../theme'

const Banner = styled('div')`
  background: ${colors.errorBg};
  border: ${borders.widthMedium} solid ${colors.errorBorder};
  border-radius: ${borders.radius};
  padding: ${spacing.md} ${spacing.lg};
  margin-bottom: ${spacing.lg};
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Message = styled('span')`
  color: ${colors.error};
  font-size: ${typography.fontSizeBase};
  font-weight: ${typography.fontWeightMedium};
`

const DismissButton = styled('button')`
  background: none;
  border: none;
  color: ${colors.error};
  cursor: pointer;
  padding: ${spacing.xs};
  font-size: ${typography.fontSizeLg};
  line-height: 1;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
`

interface ErrorBannerProps {
  message: string
  onDismiss?: () => void
}

export function ErrorBanner({ message, onDismiss }: ErrorBannerProps) {
  return (
    <Banner>
      <Message>{message}</Message>
      {onDismiss && (
        <DismissButton onClick={onDismiss} aria-label="Dismiss error">
          x
        </DismissButton>
      )}
    </Banner>
  )
}
